var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChart',{attrs:{"chart-data":_vm.config,"chart-options":_vm.options,"css-classes":"dashboard-line-chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }